import { useEffect, useState } from 'react';
import { NavLink } from 'react-router';
import { signIn, signUp } from '../auth/auth';
import { linkClassName } from '../components/ui/styles';
import { useSession } from '../context/session/useSession';
import { redirectAfterSignIn } from '../auth/redirectAfterSignIn';
import { Button } from '@fd/frontend/components/ui/Button';
export function CreateAccountForm({
  isExistingAccount = false,
}: {
  isExistingAccount?: boolean;
}) {
  const { session } = useSession();
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [errorMessage, setErrorMesage] = useState('');
  const [message, setMessage] = useState('');
  const [isLoading, setLoading] = useState(false);

  useEffect(() => {
    if (session) redirectAfterSignIn();
  }, [session]);

  const nicelySetEmail = (email: string) => {
    return setEmail(email.toLowerCase());
  };

  if (session) {
    return (
      <div className="mt-4 pb-4 border-b border-gray-200">
        <span className="font-medium">{session.user.email}</span>
      </div>
    );
  }

  return (
    <div className="">
      {!localStorage.redirectTo && (
        <p className="my-4 text-gray-500 ">
          <NavLink to={'/proxies/buy'} className={linkClassName}>
            Buy proxy
          </NavLink>
        </p>
      )}

      <div>
        <div className="mt-4">
          <label
            htmlFor="email"
            className="block text-sm font-medium leading-6 text-gray-900"
          >
            Email
          </label>
          <input
            id="email"
            value={email}
            onChange={(e) => {
              setErrorMesage('');
              nicelySetEmail(e.target.value);
            }}
            name="email"
            type="email"
            placeholder="name@example.com"
            className="block w-full rounded-md border-0 px-2 py-1.5 text-gray-900 shadow-xs ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6"
          />
        </div>
        <div className="mt-4">
          <label
            htmlFor="password"
            className="block text-sm font-medium leading-6 text-gray-900"
          >
            Password
          </label>
          <input
            id="password"
            name="password"
            type="password"
            value={password}
            onChange={(e) => {
              setErrorMesage('');
              setPassword(e.target.value);
            }}
            placeholder="***"
            className="block w-full rounded-md border-0 px-2 py-1.5 text-gray-900 shadow-xs ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6"
          />
        </div>

        <div className="pt-4">
          <Button
            variant="default"
            className="w-full"
            id={isExistingAccount ? 'login' : 'signup'}
            disabled={isLoading}
            onClick={async () => {
              setErrorMesage('');
              setMessage('');
              setLoading(true);   
              try {
                const result = isExistingAccount
                  ? await signIn(email, password)
                  : await signUp(email, password);
                if (result.ok) {
                  setMessage(result.message);
                } else {
                  setErrorMesage(result.message);
                }
              } catch {
                setErrorMesage(
                  'Unexpected error. Please contact support if it persists'
                );
              } finally {
                setLoading(false);
              }
            }}
          >
            {isExistingAccount ? <>Sign in</> : <>Sign up</>}
          </Button>
          {message && (
            <div className="p-2 my-2 bg-indigo-100 border-indigo-400 rounded-sm">
              {message}
            </div>
          )}
        </div>
        {errorMessage && (
          <div className="p-2 my-2 bg-red-100 border-red-300 text-red-700 rounded-sm">
            {errorMessage}
          </div>
        )}
      </div>
    </div>
  );
}
